import {
  Component,
  ElementRef, OnDestroy, OnInit, ViewChild
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FileUploadModule } from 'primeng/fileupload';
import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { EstadoFormDTO } from '../../../models/configuracoes/estado.model';
import { EstadoService } from '../../../services/configuracoes/estado.service';
import { TimbradoService } from '../../../services/configuracoes/timbrado.service';
import {
  AtividadeEconomicaEmpresaConfigFormDTO,
  EmpresaConfigDTO,
  EmpresaConfigFormDTO,
  certificadoDigitalEmpresaConfigDTO,
  City,
  TimbradoOption,
  UploadEvent,
} from '../../../models/configuracoes/empresa.model';
import {
  MOEDA_OPTIONS,
  Moeda,
  TipoImprimir,
  TipoRegimeContabil,
} from '../../../enums/moeda.enum';
import { TipoPadraoNota } from '../../../enums/TipoPadraoNota.enum';
import { TipoFichaEvento } from '../../../enums/TipoFichaEvento.enum';
import { TipoImpressao } from '../../../enums/TipoImpressao.enum';
import { CidadeService } from '../../../services/configuracoes/cidade.service';
import { CidadeDTO } from '../../../models/configuracoes/cidade.model';
import { PessoaDTO } from '../../../models/clientes/pessoa.model';
import { PessoaService } from '../../../services/pessoas/pessoas.service';
import { TranslateService } from '@ngx-translate/core';
import { EmpresaConfigService } from '../../../services/configuracoes/empresa.service';
import { AtividadeEconomicaDTO } from '../../../models/configuracoes/atividade-economica.model';
import { AtividadeEconomicaService } from '../../../services/configuracoes/atividade-economica.service';
import { TimbradoDTO } from '../../../models/configuracoes/timbrao.model';
import { ImpressoraDTO } from '../../../models/impressora.models';
import { ImpressoraService } from '../../../services/impressora/impressora.service';
import { ImpressoraResponseDTO } from '../../../models/impressora.models';
import { ApiService } from '../../../services/api.service';
import { toLocalISOString } from '../../../shared/utils/date-utils';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../environments/environment';
import { PaisDDI } from '../../../models/cardapio-digital/cardapio-digital.model';
import { PAISES_DDI } from '../../../shared/data/paises-ddi.data';
import { ImagemUtils } from '../../../shared/utils/imagem-utils';
import { isEmailValido } from '../../../shared/utils/email.util';
import { filtrarRucDoEvento, isDvRucValido } from '../../../shared/utils/ruc.util';



@Component({
  selector: 'app-configuracao-da-empresa',
  templateUrl: './configuracao-da-empresa.component.html',
  styleUrl: './configuracao-da-empresa.component.scss',
  providers: [ConfirmationService, MessageService],
})
export class ConfiguracaoDaEmpresaComponent implements OnInit, OnDestroy {

  private langChangeSub!: Subscription;
  env = environment;
  uploadedFiles: any[] = [];
  cidades: CidadeDTO[] = [];
  atividades: AtividadeEconomicaDTO[] = [];
  selectedCity: City | undefined;
  form: EmpresaConfigFormDTO = this.createEmptyForm();

  timbradoOptions: TimbradoDTO[] = [];
  selectedCliente: { label: string; value: PessoaDTO } | null = null;
  clientesList: { label: string; value: PessoaDTO }[] = [];
  clientesFiltrados: { label: string; value: PessoaDTO }[] = [];
  searchClienteText: string = '';
  pessoas: PessoaDTO[] = [];
  cidadeList: { label: string; value: number }[] = []; // Mude para number
  atividadesList: { label: string; value: string }[] = [];
  moeda: { label: string; value: Moeda }[] = [];
  tipoRegimeContabil: { label: string; value: TipoRegimeContabil }[] = [];
  tipoImprimir: { label: string; value: TipoImprimir }[] = [];
  tipoPadraoNotaComum: { label: string; value: string }[] = [];
  tipoPadraoNotaFiscal: { label: string; value: string }[] = [];
  tipoImpressao: { label: string; value: TipoImpressao }[] = [];
  tipoFichaEvento: { label: string; value: TipoFichaEvento }[] = [];
  visible: boolean = false;
  activeIndex: number = 0;
  estadoSelecionado: string = '';
  utilizaMultiMoeda: { label: string; value: boolean }[] = [];
  deveImprimirFicha: { label: string; value: boolean }[] = [];
  imprimirItensDeAcordoImpressora: { label: string; value: boolean }[] = [];
  idCsc: number = 0;
  csc: string = '';
  codigoEstabelecimento: string = '';
  searchNome: string = '';
  rows3: number = 5;
  totalRecords: number = 120;
  first3: number = 0;
  nomeDoEvento: string = '';
  pessoa_id: number | null = null;
  clientes: any[] = [];
  clienteSelecionado: any = null;
  timbrados: TimbradoOption[] = [];
  timbradosNotaFiscal: TimbradoOption[] = [];
  timbradoPadraoVendaId: number | null = null;
  timbradoPadraoNotaFiscalId: number | null = null;
  imageSrc: string | null = null;
  impressoraPadraoId: number | null = null;
  empresaData: EmpresaConfigDTO | null = null;
  senhaCertificadoDigital: string = '';
  fileName: string | null = null;
  imageBase64: string | null = null;
  private userSelectedNewImage = false;
  imagePreviewUrl: string | null = null;
  certificadoDigital = {
    arquivo: null as File | null,
    senha: '',
    tipo: 'A1',
    vencimento: null as Date | null,
    serialNumber: '',
    nomeArquivo: '',
    informacoes: null as any
  };
  timbradoVendaSelecionado: TimbradoOption | null = null;
  timbradoNotaFiscalSelecionado: TimbradoOption | null = null;
  tiposCertificado = [
    { label: 'A1 (Arquivo)', value: 'A1' },
    { label: 'A3 (Token/Cartão)', value: 'A3' }
  ];
  isUploadingCertificado = false;
  certificadoInfo: any = null;
  timbradoSelecionado: TimbradoOption = { value: null, code: 'VENDA_COMUM' };
  private clientePadraoId: number | null = null;
  private timbradoPadraoLabel: string | null = null;
  isFormSubmitted = false;
  carregandoDados: boolean = true;
  carregandoDadosSecundarios: boolean = true;

  // Dropdown de DDI
  paisSelecionado: PaisDDI = PAISES_DDI[0]; // Paraguay (+595)






  @ViewChild('buscaClientesInput') buscaClientesInput?: ElementRef<HTMLInputElement>;
  @ViewChild('pFileUpload') pFileUpload!: FileUpload;


  constructor(
    private pessoaService: PessoaService,
    private messageService: MessageService,
    private cidadeService: CidadeService,
    private estadoService: EstadoService,
    private timbradoService: TimbradoService,
    private impressoraService: ImpressoraService,
    private atividadeService: AtividadeEconomicaService,
    private empresaConfigService: EmpresaConfigService,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private apiService: ApiService,
  ) { }

  ngOnDestroy(): void {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.buildBooleanOptions();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => {
      this.buildBooleanOptions();
    });

    // Ler query param 'tab' para ativar aba correta (redirecionamento de erros NFe)
    const tab = this.route.snapshot.queryParamMap.get('tab');
    if (tab) {
      const tabMap: Record<string, number> = {
        'geral': 0,
        'negocio': 1,
        'atividade-economica': 2,
        'dte': 3,
        'outros': 4,
      };
      if (tabMap[tab] !== undefined) {
        this.activeIndex = tabMap[tab];
      }
    }

    // Enums síncronos (sem API)
    // Todas as moedas disponiveis (incluindo PESO) podem ser moeda padrao da empresa.
    // Usa MOEDA_OPTIONS para preservar labels canônicos (ex: "Peso Argentino" em vez de "Peso").
    this.moeda = MOEDA_OPTIONS.map(o => ({ label: o.label, value: o.value as Moeda }));
    this.tipoRegimeContabil = this.getDropItems(TipoRegimeContabil);
    this.tipoImprimir = this.getDropItems(TipoImprimir);
    this.tipoImpressao = this.getDropItems(TipoImpressao);
    this.tipoFichaEvento = this.getDropItems(TipoFichaEvento);
    this.tipoPadraoNotaComum = this.getDropItems(TipoPadraoNota);
    this.tipoPadraoNotaFiscal = this.getDropItems(TipoPadraoNota);

    // FASE 1: Prioridade - dados da aba "Informações Gerais" (cidade + empresa)
    this.carregandoDados = true;
    Promise.all([
      this.findCidade(),
      this.findEmpresaConfigPrioritario()
    ]).then(() => {
      // Cidade mapeada aqui, após garantir que cidadeList e empresaData estão prontos
      this.aplicarCidadeNoForm();
      this.carregandoDados = false;

      // FASE 2: Background - dados das outras abas (não bloqueia a tela)
      this.carregandoDadosSecundarios = true;
      Promise.all([
        this.findClientes(),
        this.findAtividadeEconomica(),
        this.carregarTimbrados()
      ]).then(() => {
        this.aplicarDadosSecundarios();
        this.sincronizarDropdownsTimbrado();
        this.carregandoDadosSecundarios = false;
      });
    });
  }

  private buildBooleanOptions(): void {
    const sim = this.translate.instant('common.sim');
    const nao = this.translate.instant('common.nao');
    this.utilizaMultiMoeda = [
      { label: sim, value: true },
      { label: nao, value: false },
    ];
    this.deveImprimirFicha = [
      { label: sim, value: true },
      { label: nao, value: false },
    ];
    this.imprimirItensDeAcordoImpressora = [
      { label: sim, value: true },
      { label: nao, value: false },
    ];
  }

  /** FASE 1: Carrega empresa e salva dados crus (cidade mapeada depois em aplicarCidadeNoForm) */
  findEmpresaConfigPrioritario(): Promise<void> {
    return new Promise((resolve) => {
      // Primeiro busca o ID da empresa da sessão do usuário logado
      this.empresaConfigService.getSessao().subscribe((sessao) => {
        if (!sessao || !sessao.id) {
          resolve();
          return;
        }
        // Depois busca os dados completos da empresa pelo ID correto
        this.empresaConfigService.get(`/configuracaoEmpresa/${sessao.id}`).subscribe((empresaData: any) => {
          if (empresaData) {
            this.empresaData = empresaData;

            // Enums (sempre disponíveis - são síncronos)
            const moedaMap = new Map(this.moeda.map(m => [m.value, m]));
            const moedaEnumValue = this.asMoedaEnum(empresaData.moeda);
            const moedaEncontrada = moedaEnumValue ? moedaMap.get(moedaEnumValue) : undefined;

            const tipoImprimirMap = new Map(this.tipoImprimir.map(t => [t.value, t]));
            const tipoImprimirEncontrado = tipoImprimirMap.get(this.asTipoImprimirEnum(empresaData.tipoImprimir));

            const regimeContabilMap = new Map(this.tipoRegimeContabil.map(r => [r.value, r]));
            const regimeEnumValue = this.asTipoRegimeContabilEnum(empresaData.tipoRegimeContabil);
            const regimeContabilEncontrado = regimeEnumValue ? regimeContabilMap.get(regimeEnumValue) : undefined;

            const tipoImpressaoEnumValue = this.asTipoImpressaoEnum(empresaData.tipoDeFormatoDaImpressao);
            const tipoImpressaoMap = new Map(this.tipoImpressao.map(t => [t.value, t]));
            const tipoImpressaoEncontrado = tipoImpressaoEnumValue
              ? tipoImpressaoMap.get(tipoImpressaoEnumValue)
              : tipoImpressaoMap.get(TipoImpressao.BOBINA_58);

            const tipoFichaEvento = this.asTipoFichaEvento(empresaData.tipoFichaDeEvento);
            const tipoFichaEventoMap = new Map(this.tipoFichaEvento.map(t => [t.value, t]));
            const tipoFichaEventoEncontrado = tipoFichaEvento
              ? tipoFichaEventoMap.get(tipoFichaEvento) : undefined;

            // Guarda IDs para aplicar depois (fase 2)
            this.clientePadraoId = empresaData?.clientePadrao?.id ?? null;

            // Popula o form com tudo que já temos (cidade aplicada depois em aplicarCidadeNoForm)
            this.form = {
              ...this.createEmptyForm(),
              nome: empresaData.nome || '',
              fantasia: empresaData.fantasia || '',
              ruc: empresaData.ruc || '',
              rodape: empresaData.rodape || '',
              email: empresaData.email || '',
              ddi: empresaData.ddi || '595',
              telefone: empresaData.telefone || '',
              endereco: empresaData.endereco || '',
              numero: empresaData.numero || '',
              informacaoNegocio: empresaData.informacaoNegocio || '',
              utilizaMultiMoeda: empresaData.utilizaMultiMoeda || false,
              deveImprimirFicha: empresaData.deveImprimirFicha || false,
              atividadesEconomicas: [],  // Preenchido na fase 2
              idCsc: empresaData.idCsc ?? 1,
              csc: empresaData.csc || '',
              codigoEstabelecimento: empresaData.codigoEstabelecimento ?? '1',
              cidade: undefined,  // Preenchido depois em aplicarCidadeNoForm (garante que cidadeList está pronta)
              moeda: moedaEncontrada,
              tipoRegimeContabil: regimeContabilEncontrado ?? undefined,
              tipoImprimir: tipoImprimirEncontrado,
              tipoImpressao: tipoImpressaoEncontrado,
              impressoraPadraoId: empresaData.impressoraPadrao?.id || undefined,
              impressoraPadraoPedidoId: (empresaData as any).impressoraPadraoPedido?.id || undefined,
              imprimirAutomaticoPedidoLocal: (empresaData as any).imprimirAutomaticoPedidoLocal || false,
              imprimirAutomaticoPedidoMinishop: (empresaData as any).imprimirAutomaticoPedidoMinishop || false,
              clientePadrao: undefined,  // Preenchido na fase 2
              timbradoPadraoVendaId: empresaData.timbradoPadraoVenda?.id || null,
              timbradoPadraoNotaFiscalId: empresaData.timbradoPadraoDeNotaFiscal?.id || null,
              logo: empresaData.logo || null,
              nomeDoEvento: empresaData.nomeDoEvento || '',
              tipoFichaEvento: tipoFichaEventoEncontrado,
              imprimirItensDeAcordoImpressora: empresaData.imprimirItensDeAcordoImpressora || false,
              tipoPadraoNotaComum: empresaData.timbradoPadraoVenda
                ? { label: empresaData.timbradoPadraoVenda.nome, value: empresaData.timbradoPadraoVenda.enum }
                : undefined,
              tipoPadraoNotaFiscal: empresaData.timbradoPadraoNotaFiscal
                ? { label: empresaData.timbradoPadraoNotaFiscal.nome, value: empresaData.timbradoPadraoNotaFiscal.enum }
                : undefined,
            };

            // Converter DDI string para PaisDDI
            const ddiComPlus = '+' + (empresaData.ddi || '595');
            this.paisSelecionado = PAISES_DDI.find(p => p.ddi === ddiComPlus) || PAISES_DDI[0];
          }
          resolve();
        });
      });
    });
  }

  /** Aplica a cidade no formulário após garantir que cidadeList e empresaData estão carregados */
  private aplicarCidadeNoForm(): void {
    if (!this.empresaData) return;

    const cidadeMap = new Map(this.cidadeList.map(c => [String(c.value), c]));
    const cidadeEncontrada = cidadeMap.get(String(this.empresaData.cidade?.id));

    this.form.cidade = cidadeEncontrada;

    // Estado vinculado à cidade
    if (this.empresaData.cidade && this.empresaData.cidade.estado) {
      this.estadoSelecionado = this.empresaData.cidade.estado.nome || '';
    } else if (cidadeEncontrada) {
      this.updateEstadoByCidadeId(this.empresaData.cidade!.id);
    }
  }

  /** FASE 2: Aplica dados que dependem de clientes, timbrados e atividades (outras abas) */
  private aplicarDadosSecundarios(): void {
    if (!this.empresaData) return;

    // Aplica cliente padrão
    this.aplicarClientePadrao();

    // Aplica timbrados
    this.timbradoVendaSelecionado = this.findTimbradoOptionById(this.form.timbradoPadraoVendaId);
    this.timbradoNotaFiscalSelecionado = this.findTimbradoOptionById(this.form.timbradoPadraoNotaFiscalId)
      || this.timbradosNotaFiscal?.[0] || null;

    // Aplica atividades econômicas
    this.loadAtividadesEconomicas(this.empresaData.atividadesEconomicasId || this.empresaData.atividadesEconomicas_id || []).then(atividades => {
      this.form.atividadesEconomicas = atividades;
    });
  }

  /** Mantido para compatibilidade com submit() */
  findEmpresaConfig(): Promise<void> {
    return this.findEmpresaConfigPrioritario();
  }



  private asMoedaEnum(value: any): Moeda | undefined {
    if (!value) return undefined;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'GUARANI':
        return Moeda.GUARANI;
      case 'REAL':
        return Moeda.REAL;
      case 'DOLAR':
        return Moeda.DOLAR;
      case 'PESO':
        return Moeda.PESO;
      default:
        return undefined;
    }
  }

  private asTipoImpressaoEnum(value: any): TipoImpressao | undefined {
    if (!value) return undefined;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'BOBINA_58':
        return TipoImpressao.BOBINA_58;
      case 'BOBINA_80':
        return TipoImpressao.BOBINA_80;
      case 'A4':
        return TipoImpressao.A4;
      default:
        return undefined; // Retorna undefined para valores desconhecidos
    }
  }

  private asTipoFichaEvento(value: any): TipoFichaEvento | undefined {
    if (!value) return undefined;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'QUANTIDADE':
        return TipoFichaEvento.QUANTIDADE;
      case 'VENDA':
        return TipoFichaEvento.VENDA;
      default:
        return undefined;
    }
  }

  private asTipoRegimeContabilEnum(value: any): TipoRegimeContabil | undefined {
    if (!value) return undefined;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'REGIME_PRODUTOR_PEQUENO_PORTE':
        return TipoRegimeContabil.REGIME_PRODUTOR_PEQUENO_PORTE;
      case 'REGIME_PRODUTOR_MEDIO_PORTE':
        return TipoRegimeContabil.REGIME_PRODUTOR_MEDIO_PORTE;
      case 'REGIME_CONTABIL':
        return TipoRegimeContabil.REGIME_CONTABIL;
      default:
        return TipoRegimeContabil.REGIME_CONTABIL;
    }
  }

  // Método auxiliar para buscar o estado baseado no ID da cidade
  private updateEstadoByCidadeId(cidadeId: string | number): void {
    const cidadeEncontrada = this.cidades.find(c => String(c.id) === String(cidadeId));
    if (cidadeEncontrada) {
      this.getEstadobyId(cidadeEncontrada.estado_id).then(estado => {
        this.estadoSelecionado = estado?.nome || '';
      });
    }
  }

  findClientes(
    page: number = 0,
    size: number = 100,
    sort: string = 'nome,asc',
  ): Promise<void> {
    return new Promise((resolve) => {
      this.pessoaService
        .get('/pessoas/buscar', {
          page,
          size,
          sort,
          filter: 'categoriaCliente=true'
        })
        .subscribe(
          (response) => {
            this.pessoas = response.content;

            // Use o mesmo mapeamento do VendasComponent
            this.clientesList = this.pessoas.map((cliente: PessoaDTO) => ({
              label: this.getClienteLabel(cliente),
              value: cliente
            }));

            // Mapeia também para this.clientes (usado por aplicarClientePadrao)
            this.clientes = this.pessoas.map((c: any) => ({ id: c.id, nome: c.nome, fantasia: c.fantasia, email: c.email, ruc: c.ruc }));

            resolve();
          },
          (error) => {
            console.error('Erro ao buscar clientes:', error);
            this.clientesList = [];
            this.clientes = [];
            resolve();
          }
        );
    });
  }


  // Método para filtrar clientes localmente (busca em tempo real)
  filtrarClientes(event: any): void {
    const query = event.query.toLowerCase();

    if (!query) {
      this.clientesFiltrados = [...this.clientesList];
      return;
    }

    this.clientesFiltrados = this.clientesList.filter(cliente =>
      cliente.label.toLowerCase().includes(query) ||
      cliente.value.ruc?.toLowerCase().includes(query) ||
      cliente.value.email?.toLowerCase().includes(query)
    );
  }

  // Método para buscar na API quando o usuário digitar
  onSearchCliente(event: any): void {
    const query = event.query;
    this.searchClienteText = query;
  }

  // Método para limpar a busca
  clearSearch(): void {
    this.searchClienteText = '';
    this.clientesFiltrados = [...this.clientesList];
  }
  // CORREÇÃO: Método para criar o label do cliente baseado na PessoaDTO
  private getClienteLabel(cliente: PessoaDTO): string {
    if (!cliente) return 'Selecionar cliente';

    // Baseado na interface PessoaDTO, temos estas propriedades disponíveis:
    if (cliente.nome && cliente.nome.trim() !== '') {
      return cliente.nome;
    }

    if (cliente.fantasia && cliente.fantasia.trim() !== '') {
      return cliente.fantasia;
    }

    if (cliente.ruc && cliente.ruc.trim() !== '') {
      return `RUC: ${cliente.ruc}`;
    }

    if (cliente.email && cliente.email.trim() !== '') {
      return cliente.email;
    }

    return `Cliente ${cliente.id || 'N/A'}`;
  }

  findCidade(): Promise<void> {
    return new Promise((resolve) => {
      this.cidadeService
        .get('/cidade?listarTodos=true')
        .subscribe((response) => {
          this.cidades = response.content;
          this.cidadeList = this.cidades.map((cidade) => ({
            label: cidade.nome,
            value: Number(cidade.id), // Converta para número
          }));
          resolve();
        });
    });
  }

  findAtividadeEconomica(): Promise<void> {
    return new Promise((resolve) => {
      this.atividadeService
        .get('/atividadeEconomica?listarTodos=true')
        .subscribe((response) => {
          this.atividades = response.content;

          // this.atividadesList = this.atividades.map((atividade) => ({
          //   label: `${atividade.codigo} - ${atividade.nome}`,
          //   value: String(atividade.id),
          // }));
          resolve();
        });
    });
  }

  getDropItems(enumType: any): { label: string; value: any }[] {
    return Object.values(enumType).map((item) => ({
      label: String(item).toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      value: item,
    }));
  }

  onUpload(event: UploadEvent) {
    for (let file of event.files) {
      this.uploadedFiles.push(file);
    }

    this.messageService.add({
      severity: 'info',
      summary: this.translate.instant('common.sucesso'),
      detail: this.translate.instant('configuracao-empresa.mensagens.arquivo_enviado'),
    });
  }

  createEmptyForm(): EmpresaConfigFormDTO {
    return {
      nome: '',
      fantasia: '',
      ruc: '',
      rodape: '',
      email: '',
      ddi: '595',
      telefone: '',
      endereco: '',
      numero: '', // não vi
      cidade: undefined,
      moeda: undefined,
      informacaoNegocio: '',
      logo: undefined,
      imagem: undefined,
      tipoRegimeContabil: undefined,
      atividadesEconomicas: [],
      tipoImprimir: undefined,
      tipoPadraoNotaComum: undefined,
      tipoPadraoNotaFiscal: undefined,
      utilizaMultiMoeda: false,
      deveImprimirFicha: false,
      idCsc: 1,
      csc: '',
      codigoEstabelecimento: '1',
      tipoImpressao: undefined,
      clientePadrao: undefined,
      nomeDoEvento: '',
      timbradoPadraoNotaFiscalId: null,
      timbradoPadraoVendaId: null,
      habilitarMiniShopping: undefined,
      imprimirItensDeAcordoImpressora: false,
      impressoraPadraoPedidoId: undefined,
      imprimirAutomaticoPedidoLocal: false,
      imprimirAutomaticoPedidoMinishop: false,
      tipoFichaEvento: undefined,
      estadoAutorizacaoNotaEletronica: undefined,
      nomeCertificadoDigital: '',
      senhaCertificadoDigital: '',
    };
  }

  addAtividadeEconomica(AtividadeEconomicas: AtividadeEconomicaDTO[]) {
    this.form.atividadesEconomicas = AtividadeEconomicas;
  }


  async submit(): Promise<void> {
    this.isFormSubmitted = true;

    // Validação de campos obrigatórios (alinhado com o app mobile)
    const temErroAba0 = !this.form.nome || !this.form.email || !this.form.telefone || !this.form.cidade;
    const temErroAba1 = !this.form.fantasia || !this.form.ruc;
    const temErroAba3 = !this.form.codigoEstabelecimento || !this.form.idCsc;
    const tipoImprimirValue = this.form.tipoImprimir?.value || this.form.tipoImprimir;
    const temErroAba4 = !this.form.tipoRegimeContabil ||
      !this.form.tipoImprimir ||
      !this.clienteSelecionado ||
      !this.timbradoNotaFiscalSelecionado ||
      (tipoImprimirValue && tipoImprimirValue !== 'NADA_A_FAZER' && !this.form.tipoImpressao);

    if (temErroAba0 || temErroAba1 || temErroAba3 || temErroAba4) {
      if (temErroAba0) {
        this.activeIndex = 0;
      } else if (temErroAba1) {
        this.activeIndex = 1;
      } else if (temErroAba3) {
        this.activeIndex = 3;
      } else if (temErroAba4) {
        this.activeIndex = 4;
      }

      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('configuracao_campos_obrigatorios'),
      });
      return;
    }

    // Salva a configuração da empresa usando dados já carregados
    if (this.empresaData && this.empresaData.id) {
      this.updateEmpresaConfig(this.empresaData.id, 'put');
    } else {
      this.updateEmpresaConfig(0, 'post');
    }

    // Upload do certificado se estiver na aba DTE e tiver arquivo selecionado
    if (this.certificadoDigital.arquivo) {
      const certificadoSalvo = await this.enviarCertificado();

      if (!certificadoSalvo) {
        this.messageService.add({
          severity: 'warn',
          summary: this.translate.instant('common.atencao'),
          detail: this.translate.instant('configuracao-empresa.mensagens.corrigir_certificado')
        });
      }
    }
  }

  private updateEmpresaConfig(id: number, method: 'post' | 'put'): void {
    const empresa: any = {
      id: this.empresaData?.id,
      nome: this.form.nome,
      fantasia: this.form.fantasia,
      ruc: this.form.ruc,
      rodape: this.form.rodape,
      email: this.form.email,
      ddi: this.paisSelecionado.ddi.replace('+', '') || '595',
      telefone: this.form.telefone?.replace(/\D/g, '') || '',
      endereco: this.form.endereco,
      numero: this.form.numero,
      cidadeId: this.form.cidade?.value,
      clientePadraoId: this.clientePadraoId,
      impressoraPadraoId: this.form.impressoraPadraoId,
      impressoraPadraoPedidoId: this.form.impressoraPadraoPedidoId,
      imprimirAutomaticoPedidoLocal: this.form.imprimirAutomaticoPedidoLocal,
      imprimirAutomaticoPedidoMinishop: this.form.imprimirAutomaticoPedidoMinishop,
      moeda: this.form.moeda?.value,
      tipoRegimeContabil: this.form.tipoRegimeContabil?.value,
      tipoImprimir: this.form.tipoImprimir?.value,
      tipoDeFormatoDaImpressao: this.form.tipoImpressao?.value,
      tipoFichaDeEvento: this.form.tipoFichaEvento?.value,
      atividadesEconomicasId: this.form.atividadesEconomicas.map(a => a.id),
      timbradoPadraoVendaId: this.form.timbradoPadraoVendaId,
      timbradoPadraoDeNotaFiscalId: this.form.timbradoPadraoNotaFiscalId,
      codigoEstabelecimento: this.form.codigoEstabelecimento ? Number(this.form.codigoEstabelecimento) : null,
      idCsc: this.form.idCsc ? Number(this.form.idCsc) : null,
      informacaoNegocio: this.form.informacaoNegocio,
      csc: this.form.csc,
      // Envia logo apenas quando o usuário selecionou uma nova imagem nesta sessão.
      // Nunca reenviar o logo carregado do servidor (base64 grande causa network error).
      logo: this.userSelectedNewImage ? this.imageBase64 : undefined,
      imagem: null,
      nomeCertificadoDigital: this.empresaData?.nomeCertificadoDigital,
      senhaCertificadoDigital: this.senhaCertificadoDigital,
      nomeDoEvento: this.form.nomeDoEvento,
      utilizaMultiMoeda: this.form.utilizaMultiMoeda,
      possuiNotaVinculada: this.empresaData?.possuiNotaVinculada,
      exibirDesistirCancelamento: this.empresaData?.exibirDesistirCancelamento,
      concluiuOsPrimeirosPassos: this.empresaData?.concluiuOsPrimeirosPassos,
      deveImprimirFicha: this.form.deveImprimirFicha,
      estadoAutorizacaoNotaEletronica: this.empresaData?.estadoAutorizacaoNotaEletronica,
      estadoAutorizacaoAutoImpressor: this.empresaData?.estadoAutorizacaoAutoImpressor,
      imprimirItensDeAcordoImpressora: this.form.imprimirItensDeAcordoImpressora,
      //vencimentoCertificadoDigital: '2025-12-31T00:00:00',
      //criadoEm: this.empresaData?.criadoEm,

      // Campos do Minishop: reenviados com os valores já carregados para evitar sobrescrita/reset no backend
      // habilitarMiniShopping é controlado exclusivamente pela tela de Configuração Mini Shop (PATCH dedicado)
      urlDoMiniShopping: this.empresaData?.urlDoMiniShopping,
      habilitarMiniShopping: this.empresaData?.habilitarMiniShopping,
      minishopGeralCorDeFundo: this.empresaData?.minishopGeralCorDeFundo,
      minishopGeralCorDaFonte: this.empresaData?.minishopGeralCorDaFonte,
      minishopBotoesCorDeFundo: this.empresaData?.minishopBotoesCorDeFundo,
      minishopBotoesCorDaFonte: this.empresaData?.minishopBotoesCorDaFonte,
      minishopGeralCorDeFundoDoTitulo: this.empresaData?.minishopGeralCorDeFundoDoTitulo,
      minishopGruposCorDeFundo: this.empresaData?.minishopGruposCorDeFundo,
      minishopGruposCorDaFonte: this.empresaData?.minishopGruposCorDaFonte,
      minishopImagemDeTitulo: this.empresaData?.minishopImagemDeTitulo,
      perfilInstagram: this.empresaData?.perfilInstagram,
      perfilFacebook: this.empresaData?.perfilFacebook,
      tipoPrecoCoberturaDeEnvio: this.empresaData?.tipoPrecoCoberturaDeEnvio?.enum || this.empresaData?.tipoPrecoCoberturaDeEnvio || null,
      latitude: this.empresaData?.latitude,
      longitude: this.empresaData?.longitude,

      atualizadoEm: toLocalISOString(),
      /*usuarioDeAdicao: null, 
      usuarioDeUltimaAlteracao: this.empresaData?.usuarioDeUltimaAlteracao  */
    };

    const endpoint = method === 'put' && id > 0
      ? `/configuracaoEmpresa/${id}`
      : `/configuracaoEmpresa`;

    // Usa putFireAndForget porque o backend retorna a entidade completa com logo base64 (~10MB)
    // que causa timeout/network error no browser. O save funciona, mas a resposta é enorme.
    const request: Observable<any> = method === 'put' && id > 0
      ? this.empresaConfigService.putFireAndForget(endpoint, empresa)
      : this.empresaConfigService.post(endpoint, empresa);

    request.subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('configuracao_salva_sucesso')
        });
      },
      error: (err: any) => {
        console.error('Erro na requisição:', err);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.getErroAmigavel(err)
        });
      },
    });
  }
  // Método auxiliar para atividades econômicas
  private getAtividadesEconomicasIds(): number[] {
    if (!this.form.atividadesEconomicas || !Array.isArray(this.form.atividadesEconomicas)) {
      return [0]; // Valor padrão do Swagger
    }

    const ids = this.form.atividadesEconomicas
      .map(a => Number(a.id))
      .filter(id => !isNaN(id) && id > 0);

    return ids.length > 0 ? ids : [0]; // Fallback para [0] como no Swagger
  }

  // Métodos auxiliares
  private formatPhoneForBackend(phone: string): string {
    if (!phone) return '';
    // Remove tudo exceto números (sem adicionar DDI, pois há campo separado)
    return phone.replace(/\D/g, '');
  }

  private getTimbradoId(timbradoValue: any): number {
    if (!timbradoValue) return 0;
    if (typeof timbradoValue === 'object' && timbradoValue.id) {
      return Number(timbradoValue.id);
    }
    return 0;
  }

  private getErroAmigavel(err: any): string {
    // Sem conexão com o servidor (status 0 = network error)
    if (!err.status || err.status === 0) {
      return this.translate.instant('erro_sem_conexao_servidor');
    }
    // Erro de payload muito grande
    if (err.status === 413) {
      return this.translate.instant('erro_payload_muito_grande');
    }
    // Erro de validação do backend
    if (err.status === 400) {
      return err?.error?.message || this.translate.instant('erro_dados_invalidos');
    }
    // Não autorizado
    if (err.status === 401 || err.status === 403) {
      return this.translate.instant('erro_sem_permissao');
    }
    // Erro interno do servidor
    if (err.status >= 500) {
      return this.translate.instant('erro_interno_servidor');
    }
    // Timeout
    if (err.status === 408 || err.name === 'TimeoutError') {
      return this.translate.instant('erro_timeout');
    }
    // Mensagem do backend se disponível
    if (err?.error?.message && typeof err.error.message === 'string') {
      return err.error.message;
    }
    return this.translate.instant('configuracao_erro_salvar');
  }

  private handleError(err: any): void {
    this.messageService.add({
      severity: 'error',
      summary: this.translate.instant('common.erro'),
      detail: this.getErroAmigavel(err),
    });
  }
  // Método para validar campos problemáticos
  private validateProblematicFields(): void {
    const problems = [];

    // Verifica telefone
    if (!this.isValidPhone(this.form.telefone)) {
      problems.push('Telefone inválido');
    }

    // Verifica RUC
    if (!this.isValidRuc(this.form.ruc)) {
      problems.push('RUC inválido');
    }

    // Verifica email
    if (!isEmailValido(this.form.email)) {
      problems.push('Email inválido');
    }

    if (problems.length > 0) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('common.atencao'),
        detail: `${this.translate.instant('configuracao-empresa.mensagens.problemas_encontrados')}: ${problems.join(', ')}`,
      });
    }
  }

  private isValidPhone(phone: string): boolean {
    const cleaned = this.cleanPhoneNumber(phone);
    return cleaned.length >= 9 && cleaned.length <= 15;
  }

  private isValidRuc(ruc: string): boolean {
    return isDvRucValido(ruc) !== false;
  }

  /** Aviso de DV invalido no RUC da empresa. So orienta: nao bloqueia o salvar. */
  get avisoRuc(): string | null {
    return isDvRucValido(this.form.ruc) === false
      ? this.translate.instant('ruc_busca.erros.dv_invalido')
      : null;
  }

  /** Mesma regra do app: digitos, um hifen e um unico DV */
  onRucInput(event: Event): void {
    this.form.ruc = filtrarRucDoEvento(event);
  }

  // Método para limpar telefone (remove caracteres não numéricos, sem adicionar DDI)
  private cleanPhoneNumber(phone: string): string {
    if (!phone) return '';
    // Remove tudo que não é número
    return phone.replace(/\D/g, '');
  }



  // CORREÇÃO: Método para formatar enums
  private formatEnumForBackend(enumValue: any): string {
    if (typeof enumValue === 'object') {
      // Se for objeto com propriedade enum
      if (enumValue.enum) {
        return enumValue.enum;
      }
      // Se for objeto com propriedade value
      if (enumValue.value) {
        return String(enumValue.value).toUpperCase();
      }
    }

    // Se for string ou outro tipo
    return String(enumValue).toUpperCase();
  }





  private aplicarTimbradoPadrao(): void {
    if (this.empresaData) {

      // Para Timbrado Padrão Venda
      if (this.empresaData.timbradoPadraoVendaId) {
        const timbradoVenda = this.timbrados.find(t =>
          t.value?.id === this.empresaData?.timbradoPadraoVendaId
        );
        if (timbradoVenda) {
          this.form.timbradoPadraoVendaId = timbradoVenda.value.id;
        }
      }

      // Para Timbrado Padrão Nota Fiscal
      if (this.empresaData.timbradoPadraoNotaFiscalId) {
        const timbradoNotaFiscal = this.timbradosNotaFiscal.find(t =>
          t.value?.id === this.empresaData?.timbradoPadraoNotaFiscalId
        );
        if (timbradoNotaFiscal) {
          this.form.timbradoPadraoNotaFiscalId = timbradoNotaFiscal.value.id;
        }
      }
    }
  }



  /** Constrói um MoedaDTO mínimo aceito pelo backend a partir do enum selecionado */
  private buildMoedaDTO(valor: string | Moeda): any { // use 'any' se não tiver MoedaDTO exportado
    const v = (valor as string).toUpperCase();
    switch (v) {
      case 'GUARANI':
        return {
          enum: 'GUARANI',
          nome: 'Guaraní',
          casasDecimais: 0,
          codigoOperacao: 'PYG',
          simbolo: 'Gs',
        };
      case 'REAL':
        return {
          enum: 'REAL',
          nome: 'Real',
          casasDecimais: 2,
          codigoOperacao: 'BRL',
          simbolo: 'R$',
        };
      case 'DOLAR':
        return {
          enum: 'DOLAR',
          nome: 'Dólar',
          casasDecimais: 2,
          codigoOperacao: 'USD',
          simbolo: '$',
        };
      default:
        // fallback seguro
        return {
          enum: 'REAL',
          nome: 'Real',
          casasDecimais: 2,
          codigoOperacao: 'BRL',
          simbolo: 'R$',
        };
    }
  }

  abrirDialogo() {
    this.visible = true;
  }

  private labelTipoPadraoNota(code: keyof typeof TipoPadraoNota | string): string {
    return this.translate.instant(`enums.tipo_padrao_nota.${code}`);
  }



  dialog(visible: boolean) {
    this.visible = visible;
  }
  getEstadobyId(id: number): Promise<EstadoFormDTO> {
    return new Promise((resolve) => {
      this.estadoService.get(`/estado/${id}`).subscribe((response: any) => {
        // Converte EstadoResponseDTO para EstadoFormDTO
        const estadoForm: EstadoFormDTO = {
          id: response.id,
          nome: response.nome,
          pais: { label: response.pais.nome, value: response.pais.id },
          codigoFaturaEletronica: response.codigoFaturaEletronica || '',
          // Adicione outros campos necessários conforme EstadoResponseDTO
          // Adicione outros campos necessários conforme EstadoFormDTO
        };
        resolve(estadoForm);
      });
    });
  }

  onCidadeChange(event: any) {
    const cidadeId = event.value?.value || event.value;
    const cidadeEncontrada = this.cidades.find(c => String(c.id) === String(cidadeId));

    if (cidadeEncontrada) {
      // procura o estado correspondente
      const estadoEncontrado = this.getEstadobyId(cidadeEncontrada.estado_id);
      estadoEncontrado.then(estado => {
        this.estadoSelecionado = estado?.nome || '';
      });
      // this.estadoSelecionado = estadoEncontrado?.label || '';
    } else {
      this.estadoSelecionado = '';
    }
  }


  private asEnumString(v: any): string {
    if (!v) return '';

    // Se for um objeto com propriedade 'enum'
    if (typeof v === 'object' && 'enum' in v) {
      return String(v.enum).toUpperCase();
    }

    // Se for uma string, retorna em uppercase
    if (typeof v === 'string') {
      return v.toUpperCase();
    }

    // Se for um objeto do dropdown {label, value}
    if (typeof v === 'object' && 'value' in v) {
      return String(v.value).toUpperCase();
    }

    return String(v ?? '').toUpperCase();
  }
  getTranslatedLabel(value: boolean): string {
    const option = this.utilizaMultiMoeda.find(item => item.value === value);
    return option ? option.label : '';
  }

  onClienteSelecionado(cliente: any): void {
    this.pessoa_id = cliente?.id ?? null;
    this.clientePadraoId = cliente?.id ?? null;
  }

  private loadAtividadesEconomicas(atividadesIds: number[]): Promise<AtividadeEconomicaDTO[]> {
    return new Promise((resolve) => {
      if (!atividadesIds || atividadesIds.length === 0) {
        resolve([]);
        return;
      }

      // Reutiliza os dados já carregados por findAtividadeEconomica()
      if (this.atividades && this.atividades.length > 0) {
        const atividadesDaEmpresa = this.atividades.filter(atividade =>
          atividadesIds.includes(Number(atividade.id))
        );
        resolve(atividadesDaEmpresa);
      } else {
        // Fallback: carrega se por algum motivo não estiverem disponíveis
        this.atividadeService.get('/atividadeEconomica?listarTodos=true').subscribe({
          next: (response) => {
            const todasAtividades = response.content;
            const atividadesDaEmpresa = todasAtividades.filter(atividade =>
              atividadesIds.includes(Number(atividade.id))
            );
            resolve(atividadesDaEmpresa);
          },
          error: (error) => {
            console.error('Erro ao carregar atividades econômicas:', error);
            resolve([]);
          }
        });
      }
    });
  }

  private aplicarClientePadrao(): void {
    if (!this.clientePadraoId || !this.clientes?.length) return;
    const found = this.clientes.find((c) => c.id === this.clientePadraoId);
    if (found) { this.clienteSelecionado = found; this.pessoa_id = found.id; }
  }

  private asTipoImprimirEnum(value: any): TipoImprimir {
    if (!value) return TipoImprimir.PERGUNTAR;

    const stringValue = this.asEnumString(value).toUpperCase();

    switch (stringValue) {
      case 'PERGUNTAR':
        return TipoImprimir.PERGUNTAR;
      case 'IMPRIMIR':
        return TipoImprimir.IMPRIMIR;
      case 'NADA_A_FAZER':
        return TipoImprimir.NADA_A_FAZER;
      default:
        return TipoImprimir.PERGUNTAR;
    }
  }

  onInputChange(event: any) {
    const value = event.target.value;
    if (value.length > 50) {
      this.form.nomeDoEvento = value.substring(0, 50);
    }
  }

  findTimbrado(
    page: number = 0,
    size: number = this.rows3,
    sort: string = 'id,asc'
  ) {
    // REMOVIDO DO FLUXO PRINCIPAL: Este método não é mais chamado no ngOnInit
    // Mantido apenas para casos específicos (paginação futura, etc)
    this.timbradoService
      .get('/timbrado', { page, size, sort })
      .subscribe((response) => {
        this.timbradoOptions = response.content;
        this.totalRecords = response.totalElements;
        this.first3 = page * size;
      });
  }

  // Método para formatar a exibição do timbrado no dropdown
  getTimbradoLabel(timbrado: TimbradoDTO): string {
    if (!timbrado) return 'Selecionar timbrado';

    return `Timbrado ${timbrado.codigoTimbrado} - ${timbrado.timbrado} (${timbrado.tipoNota})`;
  }

  separaTimbradocomoTipoNota() {
    if (!this.timbradoOptions || this.timbradoOptions.length === 0) return;

    this.timbradosNotaFiscal = []; // limpa antes de preencher
    for (const timbrado of this.timbradoOptions) {
      if (
        timbrado.tipoNota &&
        typeof timbrado.tipoNota === 'object' &&
        'enum' in timbrado.tipoNota &&
        (
          (timbrado.tipoNota as { enum?: string }).enum === TipoPadraoNota.ELETRONICA
        )
      ) {
        this.timbradosNotaFiscal.push({
          label: timbrado.timbrado,
          value: timbrado,
          code: (timbrado.tipoNota as { enum?: string }).enum ?? ''
        });
      }
    }
  }

  carregarTimbrados(): Promise<void> {
    return new Promise((resolve) => {
      this.timbradoService.get('/timbrado?listarTodos=true').subscribe({
        next: (res) => {
          // Para Timbrado Padrão Venda: filtra somente timbrados de venda (tipoDeTransacao === 'VENDA')
          const timbradosVenda = (res?.content ?? [])
            .filter((t: any) => {
              const tipo = t?.tipoDeTransacao;
              const tipoEnum = tipo && typeof tipo === 'object' && 'enum' in tipo ? tipo.enum : tipo;
              return tipoEnum === 'VENDA';
            })
            .map((t: any) => ({
              label: this.formatTimbradoLabel(t),
              value: t,
              code: t?.tipoNota?.enum ?? ''
            }));

          this.timbrados = [
            {
              label: this.labelTipoPadraoNota('VENDA_COMUM'),
              value: null,
              code: 'VENDA_COMUM'
            },
            ...timbradosVenda
          ];

          // Para Timbrado Padrão Nota Fiscal: filtra por tipoDeTransacao === 'DEVOLUCAO' (alinhado com o app mobile)
          const timbradosNotaFiscalFiltrados = (res?.content ?? [])
            .filter((t: any) => {
              const tipo = t?.tipoDeTransacao;
              const tipoEnum = tipo && typeof tipo === 'object' && 'enum' in tipo ? tipo.enum : tipo;
              return tipoEnum === 'DEVOLUCAO';
            })
            .map((t: any) => ({
              label: this.formatTimbradoLabel(t),
              value: t,
              code: t?.tipoNota?.enum ?? ''
            }));

          this.timbradosNotaFiscal = [
            {
              label: this.labelTipoPadraoNota('VENDA_COMUM'),
              value: null,
              code: 'VENDA_COMUM'
            },
            ...timbradosNotaFiscalFiltrados
          ];
          resolve();
        },
        error: (error) => {
          console.error('Erro ao carregar timbrados:', error);
          resolve();
        }
      });
    });
  }

  /** Formata o label do timbrado no mesmo padrão usado na página de vendas */
  private formatTimbradoLabel(t: any): string {
    const tipoNotaEnum = t?.tipoNota && typeof t.tipoNota === 'object' ? t.tipoNota.enum : (t?.tipoNota ?? '');
    const raw = this.translate.instant(`enums.tipo_padrao_nota.${tipoNotaEnum}`);
    const nomeTipoNota = raw.charAt(0).toUpperCase() + raw.slice(1).toLowerCase();
    const filial = String(t?.numeroFilial ?? '').padStart(3, '0');
    const expedicao = String(t?.pontoDeExpedicao ?? '').padStart(3, '0');
    const numero = String(t?.proximoNumero ?? '').padStart(7, '0');
    return `${nomeTipoNota} - ${filial}-${expedicao}-${numero}`;
  }

  onFileSelect(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => (this.imageSrc = reader.result as string);
      reader.readAsDataURL(file);
    }
  }
  onTimbradoChange(event: any, tipo: 'venda' | 'notaFiscal'): void {
    if (tipo === 'venda') {
      this.timbradoVendaSelecionado = event.value;
      this.form.timbradoPadraoVendaId = event.value?.value?.id || null;
    } else if (tipo === 'notaFiscal') {
      this.timbradoNotaFiscalSelecionado = event.value;
      this.form.timbradoPadraoNotaFiscalId = event.value?.value?.id || null;
    }
  }

  // Método para comparar objetos no dropdown
  compareTimbrados(o1: TimbradoOption | null, o2: TimbradoOption | null): boolean {

    if (!o1 || !o2) {
      const result = o1 === o2;
      return result;
    }

    // Se ambos são VENDA_COMUM (value = null)
    if (o1.value === null && o2.value === null) {
      return true;
    }

    // Se ambos têm objetos com ID
    if (o1.value && o2.value && o1.value.id && o2.value.id) {
      const result = o1.value.id === o2.value.id;
      return result;
    }

    const result = o1 === o2;
    return result;
  }

  uploadImage(file: File): void {
    this.messageService.add({
      severity: 'success',
      summary: this.translate.instant('common.sucesso'),
      detail: this.translate.instant('imagem_carregada_sucesso'),
    });
  }



  async onSelectImage(event: any) {
    const file: File | undefined = event.files?.[0];
    if (!file) { return; }

    if (!file.type.startsWith('image/')) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('selecione_apenas_arquivos_imagem')
      });
      return;
    }

    this.fileName = file.name;

    // DataURL (para preview) e Base64 sem prefixo (para enviar)
    const imagem = await ImagemUtils.comprimirParaBase64(file);
    this.imagePreviewUrl = imagem.dataUrl;
    this.imageBase64 = imagem.base64;
    this.userSelectedNewImage = true;

    this.form.imagem = this.imageBase64;
  }


  onClearImage() {
    this.fileName = null;
    this.imageBase64 = null;
    this.userSelectedNewImage = false;
    this.imagePreviewUrl = null;
    this.form.imagem = '';
  }

  abreSelec(): void {
    if (this.pFileUpload) {
      this.pFileUpload.choose();
    }
  }

  private detectMimeType(base64Data: string): string {
    // Verifica os primeiros caracteres para determinar o tipo
    if (base64Data.startsWith('/9j/') || base64Data.startsWith('iVBORw0KGgo')) {
      return 'image/jpeg';
    } else if (base64Data.startsWith('iVBORw0KGgo')) {
      return 'image/png';
    } else if (base64Data.startsWith('R0lGODlh')) {
      return 'image/gif';
    } else if (base64Data.startsWith('UklGR')) {
      return 'image/webp';
    }

    // Fallback para png
    return 'image/png';
  }

  private loadEmpresaImage(empresaData: any): void {
    // Verifica se existe logo ou imagem na empresa
    const imageData = empresaData.logo || empresaData.imagem;

    if (imageData) {

      // Se a imagem é um nome de arquivo (como "logo_646N15L477.jpg")
      if (this.isFileName(imageData)) {
        this.fileName = imageData;
        // Tenta carregar a imagem do assets primeiro
        this.tryLoadImageFromAssets(imageData);
      }
      // Se a imagem já está em base64, usa diretamente
      else if (this.isBase64(imageData)) {
        this.imageBase64 = imageData;
        this.imagePreviewUrl = this.createDataUrl(imageData);
        this.imageSrc = this.imagePreviewUrl;
        this.form.imagem = this.imageBase64;
      }
      // Se for uma URL completa
      else if (this.isUrl(imageData)) {
        this.imagePreviewUrl = imageData;
        this.imageSrc = imageData;
      }
      else {
        this.setDefaultImage();
      }
    } else {
      this.setDefaultImage();
    }
  }

  // Verifica se é um nome de arquivo
  private isFileName(str: string): boolean {
    if (!str || typeof str !== 'string') return false;

    // Padrões comuns de nomes de arquivo de imagem
    const fileNamePatterns = [
      /^logo_/i,
      /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i,
      /^[a-zA-Z0-9_\-]+\.[a-zA-Z0-9]+$/
    ];

    return fileNamePatterns.some(pattern => pattern.test(str));
  }

  // Verifica se é uma URL
  private isUrl(str: string): boolean {
    if (!str || typeof str !== 'string') return false;
    try {
      new URL(str);
      return true;
    } catch {
      return false;
    }
  }

  // Tenta carregar a imagem do diretório assets
  private tryLoadImageFromAssets(fileName: string): void {
    const assetsPath = `assets/images/${fileName}`;

    // Cria uma imagem temporária para testar se existe
    const img = new Image();
    img.onload = () => {
      this.imagePreviewUrl = assetsPath;
      this.imageSrc = assetsPath;

      // Converte para base64 para salvar no form
      this.convertImageUrlToBase64(assetsPath).then(base64 => {
        this.imageBase64 = base64;
        this.form.imagem = base64;
      }).catch(() => {
        // Falha ao converter imagem para base64
      });
    };

    img.onerror = () => {
      this.loadImageFromServer(fileName);
    };

    img.src = assetsPath;
  }

  // Carrega imagem do servidor baseado no nome do arquivo
  private loadImageFromServer(fileName: string): void {
    const serverImageUrl = `/api/images/${fileName}`;

    const img = new Image();
    img.onload = () => {
      this.imagePreviewUrl = serverImageUrl;
      this.imageSrc = serverImageUrl;

      // Converte para base64
      this.convertImageUrlToBase64(serverImageUrl).then(base64 => {
        this.imageBase64 = base64;
        this.form.imagem = base64;
      }).catch(error => {
        console.error('Erro ao converter imagem para base64:', error);
      });
    };

    img.onerror = () => {
      console.error('Imagem não encontrada no servidor:', fileName);
      this.setDefaultImage();
    };

    img.src = serverImageUrl;
  }

  // Converte URL da imagem para base64
  private convertImageUrlToBase64(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        canvas.width = img.width;
        canvas.height = img.height;

        ctx?.drawImage(img, 0, 0);

        try {
          const dataUrl = canvas.toDataURL('image/png');
          const base64 = this.stripDataUrlPrefix(dataUrl);
          resolve(base64);
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        reject(new Error('Erro ao carregar imagem da URL'));
      };

      img.src = url;
    });
  }

  // Método auxiliar para definir imagem padrão ou limpar
  private setDefaultImage(): void {
    this.imageBase64 = null;
    this.imagePreviewUrl = null;
    this.imageSrc = null;
    this.fileName = null;
    this.form.imagem = '';
  }

  // Atualize também o método isBase64 para ser mais preciso
  private isBase64(str: string): boolean {
    if (!str || typeof str !== 'string') return false;

    // Remove possíveis espaços
    const cleanStr = str.trim();

    if (cleanStr === '') return false;

    try {
      // Verifica se é base64 válido
      return btoa(atob(cleanStr)) === cleanStr;
    } catch (err) {
      // Se não for base64 válido, verifica se tem caracteres base64
      const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
      return base64Regex.test(cleanStr);
    }
  }

  // Método para criar data URL a partir de base64
  private createDataUrl(base64Data: string): string {
    // Verifica se já tem o prefixo data URL
    if (base64Data.startsWith('data:')) {
      return base64Data;
    }

    // Tenta determinar o tipo da imagem
    const mimeType = this.detectMimeType(base64Data);

    return `data:${mimeType};base64,${base64Data}`;
  }



  // Método para remover imagem
  removeImage(event: Event): void {
    event.stopPropagation();
    this.setDefaultImage();

    // Limpa o input file
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }

  // Método quando um novo arquivo é selecionado
  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file) {
      // Verifica se é uma imagem
      if (!file.type.match('image.*')) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.translate.instant('selecione_apenas_arquivos_imagem')
        });
        return;
      }

      // Verifica o tamanho do arquivo (opcional - máximo 2MB)
      if (file.size > 2 * 1024 * 1024) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.translate.instant('imagem_tamanho_excedido'),
        });
        return;
      }

      this.fileName = file.name;

      // Comprime, converte para base64 e cria preview
      ImagemUtils.comprimirParaBase64(file).then((imagem) => {
        this.imageBase64 = imagem.base64;
        this.userSelectedNewImage = true;
        this.imagePreviewUrl = imagem.dataUrl;
        this.imageSrc = imagem.dataUrl;
        this.form.imagem = this.imageBase64;

        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant('common.sucesso'),
          detail: this.translate.instant('imagem_carregada_sucesso')
        });
      });
    }
  }

  // Remove o prefixo data URL (usado na conversão de imagem vinda de URL)
  private stripDataUrlPrefix(dataUrl: string): string {
    const idx = dataUrl.indexOf('base64,');
    return idx >= 0 ? dataUrl.substring(idx + 7) : dataUrl;
  }

  onCertificadoSelected(event: any) {
    const file = event.target.files[0];

    if (file) {
      // Validar tipo de arquivo - foco em PFX/P12
      const allowedExtensions = ['.pfx', '.p12'];
      const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.translate.instant('certificado_tipo_invalido')
        });
        return;
      }

      // Validar tamanho do arquivo (máximo 5MB)
      if (file.size > 5 * 1024 * 1024) {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('common.erro'),
          detail: this.translate.instant('tamanho_maximo')
        });
        return;
      }

      this.certificadoDigital.arquivo = file;
      this.certificadoDigital.nomeArquivo = file.name;

      this.messageService.add({
        severity: 'info',
        summary: this.translate.instant('common.info'),
        detail: this.translate.instant('certificado_selecionado')
      });
    }
  }

  // Método para remover certificado
  removerCertificado() {
    this.certificadoDigital.arquivo = null;
    this.certificadoDigital.nomeArquivo = '';
    this.certificadoDigital.senha = '';
    this.certificadoInfo = null;

    // Resetar input file
    const fileInput = document.getElementById('certificado-digital-file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    this.messageService.add({
      severity: 'info',
      summary: this.translate.instant('common.info'),
      detail: this.translate.instant('certificado_removido')
    });
  }



  // Método separado para salvar configuração da empresa
  private salvarConfiguracaoEmpresa(): Promise<boolean> {
    return new Promise((resolve) => {
      this.empresaConfigService.get('/configuracaoEmpresa').subscribe({
        next: (response) => {
          if (response && response.length > 0) {
            const empresa = response[0];
            this.updateEmpresaConfig(empresa.id, 'put');
          } else {
            this.updateEmpresaConfig(0, 'post');
          }
          resolve(true);
        },
        error: (err) => {
          console.error('Erro ao buscar configuração da empresa:', err);
          this.messageService.add({
            severity: 'error',
            summary: this.translate.instant('common.erro'),
            detail: this.translate.instant('configuracao_erro_buscar_configuracao_da_empresa')
          });
          resolve(false);
        },
      });
    });
  }

  // No seu configuracao-da-empresa.component.ts

  // Mude de private para public
  public formatarTamanhoArquivo(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // Também verifique se estes métodos estão públicos:
  public determinarTipoCertificado(nomeArquivo: string): string {
    if (nomeArquivo.toLowerCase().includes('a1')) return 'A1';
    if (nomeArquivo.toLowerCase().includes('a3')) return 'A3';
    return 'A1';
  }

  public calcularDiasRestantes(dataFim: string): number {
    const hoje = new Date();
    const fim = new Date(dataFim);
    const diffTime = fim.getTime() - hoje.getTime();
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  // O método validarCertificado também precisa ser público se for usado no template
  public validarCertificado(): boolean {
    if (!this.certificadoDigital.arquivo) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('Selecione_o_certificado_digital')
      });
      return false;
    }

    if (!this.certificadoDigital.senha) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('Informe_a_senha_do_certificado_digital')
      });
      return false;
    }

    // Validação específica para PFX/P12
    const fileExtension = '.' + this.certificadoDigital.arquivo.name.split('.').pop()?.toLowerCase();
    if (!['.pfx', '.p12'].includes(fileExtension)) {
      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: this.translate.instant('configuracao-empresa.mensagens.tipo_arquivo_invalido_certificado')
      });
      return false;
    }

    return true;
  }

  // No seu componente, use este método:
  async enviarCertificado(): Promise<boolean> {
    if (!this.validarCertificado()) {
      return false;
    }

    this.isUploadingCertificado = true;

    try {
      // Debug do FormData
      const formData = new FormData();
      formData.append('certificadoDigital', this.certificadoDigital.arquivo!);
      formData.append('senha', this.certificadoDigital.senha);

      // Enviar via método multipart
      await new Promise((resolve, reject) => {
        this.empresaConfigService.uploadCertificadoDigitalMultipart(
          this.certificadoDigital.arquivo!,
          this.certificadoDigital.senha
        ).subscribe({
          next: (result) => {
            resolve(result);
          },
          error: (error) => {
            console.error('Erro:', error);
            reject(error);
          }
        });
      });

      // Atualizar estado local
      this.certificadoInfo = {
        nome: this.certificadoDigital.nomeArquivo,
        tamanho: this.formatarTamanhoArquivo(this.certificadoDigital.arquivo!.size),
        tipo: this.certificadoDigital.tipo,
        status: 'salvo'
      };

      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('common.sucesso'),
        detail: this.translate.instant('configuracao-empresa.mensagens.certificado_salvo')
      });

      return true;

    } catch (error: any) {
      console.error('Erro ao salvar certificado:', error);

      let errorMessage = this.translate.instant('configuracao-empresa.mensagens.erro_salvar_certificado');

      if (error.error) {
        if (typeof error.error === 'string') {
          errorMessage = this.tratarMensagemErro(error.error);
        } else if (error.error.message) {
          errorMessage = this.tratarMensagemErro(error.error.message);
        }
      }

      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: errorMessage
      });

      return false;
    } finally {
      this.isUploadingCertificado = false;
    }
  }

  // Método para testar certificado - também usando FormData
  async testarCertificado() {
    if (!this.certificadoDigital.arquivo || !this.certificadoDigital.senha) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translate.instant('common.atencao'),
        detail: this.translate.instant('configuracao-empresa.mensagens.selecione_certificado_senha')
      });
      return;
    }

    this.isUploadingCertificado = true;

    try {
      // Enviar teste via FormData
      await new Promise((resolve, reject) => {
        this.empresaConfigService.uploadCertificadoDigitalMultipart(
          this.certificadoDigital.arquivo!,
          this.certificadoDigital.senha
        ).subscribe({
          next: (result) => {
            resolve(result);
          },
          error: (error) => {
            console.error('Erro no teste:', error);
            reject(error);
          }
        });
      });

      this.messageService.add({
        severity: 'success',
        summary: this.translate.instant('common.sucesso'),
        detail: this.translate.instant('configuracao-empresa.mensagens.certificado_validado')
      });

      // Atualizar informações locais
      this.certificadoInfo = {
        nome: this.certificadoDigital.nomeArquivo,
        tamanho: this.formatarTamanhoArquivo(this.certificadoDigital.arquivo!.size),
        tipo: this.certificadoDigital.tipo,
        status: 'validado'
      };

    } catch (error: any) {
      let errorMessage = this.translate.instant('configuracao-empresa.mensagens.erro_testar_certificado');

      if (error.error) {
        if (typeof error.error === 'string') {
          errorMessage = this.tratarMensagemErro(error.error);
        } else if (error.error.message) {
          errorMessage = this.tratarMensagemErro(error.error.message);
        }
      }

      this.messageService.add({
        severity: 'error',
        summary: this.translate.instant('common.erro'),
        detail: errorMessage
      });
    } finally {
      this.isUploadingCertificado = false;
    }
  }

  // Método auxiliar para tratar mensagens de erro
  private tratarMensagemErro(mensagem: string): string {
    const msgLower = mensagem.toLowerCase();

    if (msgLower.includes('senha') || msgLower.includes('password')) {
      return this.translate.instant('erro_senha_certificado');
    } else if (msgLower.includes('keystore') || msgLower.includes('vazio')) {
      return this.translate.instant('erro_keystore_certificado');
    } else if (msgLower.includes('pkcs12')) {
      return this.translate.instant('erro_pkcs12_certificado');
    } else if (msgLower.includes('not found') || msgLower.includes('404')) {
      return this.translate.instant('erro_endpoint_nao_encontrado');
    } else if (msgLower.includes('internal server') || msgLower.includes('500')) {
      return this.translate.instant('erro_interno_servidor');
    } else if (msgLower.includes('connection') || msgLower.includes('0')) {
      return this.translate.instant('erro_conexao_servidor');
    }

    return this.translate.instant('erro_geral_certificado');
  }

  // Método auxiliar para encontrar o TimbradoOption pelo ID
  private findTimbradoOptionById(id: number | null | undefined): TimbradoOption | null {
    if (id === null || id === undefined) {
      return null;
    }
    // Procura primeiro nos timbrados de venda
    let timbradoEncontrado = this.timbrados.find(t => t.value?.id === id);

    // Se não encontrou, procura nos timbrados de nota fiscal
    if (!timbradoEncontrado) {
      timbradoEncontrado = this.timbradosNotaFiscal.find(t => t.value?.id === id);
    }
    return timbradoEncontrado || null;
  }

  private sincronizarDropdownsTimbrado(): void {
    // Verifica se as listas de timbrados estão carregadas
    if (!this.timbrados || !this.timbradosNotaFiscal) {
      return;
    }

    // Sincroniza Timbrado Venda
    if (this.form.timbradoPadraoVendaId !== null && this.form.timbradoPadraoVendaId !== undefined) {
      const timbradoEncontrado = this.findTimbradoOptionById(this.form.timbradoPadraoVendaId);

      if (timbradoEncontrado) {
        this.timbradoVendaSelecionado = timbradoEncontrado;
      } else {
        // Fallback para VENDA_COMUM
        this.timbradoVendaSelecionado = this.timbrados.find(t => t.value === null) || null;
      }
    } else {
      // Se for null, usa VENDA_COMUM
      this.timbradoVendaSelecionado = this.timbrados.find(t => t.value === null) || null;
    }

    // Sincroniza Timbrado Nota Fiscal
    if (this.form.timbradoPadraoNotaFiscalId !== null && this.form.timbradoPadraoNotaFiscalId !== undefined) {
      const timbradoEncontrado = this.findTimbradoOptionById(this.form.timbradoPadraoNotaFiscalId);

      if (timbradoEncontrado) {
        this.timbradoNotaFiscalSelecionado = timbradoEncontrado;
      } else {
        this.timbradoNotaFiscalSelecionado = this.timbradosNotaFiscal?.[0] || null;
      }
    } else {
      this.timbradoNotaFiscalSelecionado = this.timbradosNotaFiscal?.[0] || null;
    }
  }

  get hasLogo(): boolean {
    return !!(this.imageSrc || this.empresaData?.logo);
  }



}

